import lang from "@/views/modules/UserDashlets/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_NAME,
    },
    'user_type': {
        label: lang.LBL_USER_TYPE,
        type:'select',
        field_infos:'user_type'
    },
};
export default { searchFieldsDef }